import DefaultConfig from './DefaultConfig'

export default class HeaderConfig extends DefaultConfig
{
    options() {
        let options = super.options()

        options.autoresize_min_height = 100
        options.autoresize_bottom_margin = 0

        return options;
    }
}